import React, { Component, Fragment } from 'react'
import AppURL from '../api/AppURL'
import FooterDesktop from '../components/common/FooterDesktop'
import FooterMobile from '../components/common/FooterMobile'
import NavMenuDesktop from '../components/common/NavMenuDesktop'
import NavMenuMobile from '../components/common/NavMenuMobile'
import ProductDetails from '../components/ProductDetails/ProductDetails'
import SuggestedProduct from '../components/ProductDetails/SuggestedProduct'
import axios from 'axios'
import SliderLoading from '../components/PlaceHolder/SliderLoading'
import { useParams } from 'react-router-dom';

function ProductDetailsPageWrapper(props) {
     const { code } = useParams();
     return <ProductDetailsPage {...props} code={code} />;
}

class ProductDetailsPage extends Component {

     constructor(props) {
          super(props);
          this.state = {
               code: props.code,
               ProductData: [],
               isLoading: true,  // Initially show loading state
               mainDiv: "d-none",
               prevCode: null // track the previous product code
          }
     }

     componentDidMount() {
          this.fetchProductData(this.props.code);
          window.scroll(0, 0);
     }

     // When props (code) change, check if it’s different from the previous code
     componentDidUpdate(prevProps) {
          if (this.props.code !== prevProps.code) {
               // Reset loading state before fetching new data
               this.setState({
                    isLoading: true,
                    mainDiv: "d-none",
                    prevCode: prevProps.code // Save previous code
               });
               this.fetchProductData(this.props.code);
               window.scroll(0, 0);
          }
     }

     // Function to fetch the product data
     fetchProductData(code) {
          axios.get(AppURL.ProductDetails(code)).then(response => {
               this.setState({
                    ProductData: response.data,
                    isLoading: false,
                    mainDiv: "",
               });
          }).catch(error => {
               console.error("Error loading product data", error);
          });
     }

     render() {

          const User = this.props.user;

          if(this.state.mainDiv === "d-none"){

               return (
                    <Fragment> 
                    <div className="Desktop">
                     <NavMenuDesktop /> 
                    </div>
     
                    <div className="Mobile">
                    <NavMenuMobile />  
                    </div>                       
     
                     <SliderLoading isLoading={this.state.isLoading} />
                    
                    
                    <div className="Desktop">
                    <FooterDesktop/>
                    </div>
     
                    <div className="Mobile">
                    <FooterMobile/>
                    </div>
                    
               </Fragment>
               )


          }else{


               return (
                    <Fragment> 
                    <div className="Desktop">
                     <NavMenuDesktop /> 
                    </div>
     
                    <div className="Mobile">
                    <NavMenuMobile />  
                    </div>                       
     
                    <ProductDetails data={this.state.ProductData} user={User} /> 
                    
                    
                    <div className="Desktop">
                    <FooterDesktop/>
                    </div>
     
                    <div className="Mobile">
                    <FooterMobile/>
                    </div>
                    
               </Fragment>
               )


          }




          
     }
}

export default ProductDetailsPageWrapper;
